import { Link, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { openExternal } from 'utils/openExternal';

export function Footer() {
  const { t } = useTranslation();
  const [versionName, setVersionName] = useState<string>();

  useEffect(() => {
    window.electron?.getAppVersion?.().then((version) => setVersionName(`dj-play.it ${version}`));
  }, []);

  return (
    <Stack
      spacing={2}
      direction="row"
      justifyContent="center"
      component="footer"
      sx={{
        fontSize: '.75rem',
      }}
    >
      <Typography sx={{ color: 'text.secondary', fontSize: 'inherit' }}>{versionName}</Typography>
      <Typography sx={{ color: 'text.secondary', fontSize: 'inherit' }}>
        © Five Lemons UG
      </Typography>
      <Link
        href=""
        underline="hover"
        onClick={() => openExternal('https://five-lemons.com/')}
        sx={{ color: 'inherit' }}
      >
        {t('imprint', 'Imprint')}
      </Link>
      {/* <Link
        href=""
        underline="hover"
        onClick={() => openExternal('https://dj-play.it/agb')}
        sx={{ color: 'inherit' }}
      >
        AGB
      </Link> */}
      <Link
        href=""
        underline="hover"
        onClick={() => openExternal('https://dj-play.it/privacy')}
        sx={{ color: 'inherit' }}
      >
        {t('privacy', 'Privacy')}
      </Link>
    </Stack>
  );
}
